import { InjectionToken } from "@angular/core";
import {MensajeServiceInterface} from "..";

export const MensajeServicesTokens: Map<string, InjectionToken<MensajeServiceInterface>> = new Map();

// MensajeServicesTokens.set('some', new InjectionToken<MensajeServiceInterface>('some'));
